"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ShippingMethods = void 0;
var ShippingMethods;
(function (ShippingMethods) {
    ShippingMethods["CorreiosPac"] = "1";
    ShippingMethods["CorreiosSEDEX"] = "2";
    ShippingMethods["CorreiosPacMini"] = "17";
    ShippingMethods["JadlogPackage"] = "3";
    ShippingMethods["JadlogCom"] = "4";
})(ShippingMethods = exports.ShippingMethods || (exports.ShippingMethods = {}));
//# sourceMappingURL=types.js.map